/* eslint-disable import/no-cycle */
import isExcludedParam from '../../../../config/paramExcludes';
// eslint-disable-next-line sort-imports
import PageTitle from '../../../../lib/pageTitle';

// eslint-disable-next-line import/prefer-default-export
export const isValidURLParam = (state, getters) => (param) => (
  Object.hasOwn(getters.urlParams, param)
  || isExcludedParam(getters.isInternal, param)
);

export const updateUrlParametersNative = ({ getters }, params) => {
  if (params.productID && (params.partNumber || params.identifier)) {
    // eslint-disable-next-line no-param-reassign
    params.productID = false;
  }
  const baseUrl = `${window.location.origin}/${window.AppData.locale}/`;
  const internalStateParams = { ...(params || {}) };
  let newQueryString = `${new URLSearchParams(Object.keys(internalStateParams)
    .filter((k) => !!internalStateParams[k])
    .reduce((acc, curr) => { acc[curr] = encodeURIComponent(internalStateParams[curr]); return acc; }, {}))
    .toString()}`;

  newQueryString = newQueryString.length ? `?${decodeURIComponent(newQueryString)}` : '';

  const newFullUrl = `${baseUrl}${newQueryString}`;
  const isTransitionFlag = new URLSearchParams(window.location.search).get('focus');
  const isNewFullUrlDifferent = window.location.href !== newFullUrl;
  const isNewQueryParamsDifferent = newQueryString !== window.location.search;

  if (isNewFullUrlDifferent && isNewQueryParamsDifferent) {
    if ((!params.productID
      && !getters.product.displayName)
      && (!params.faq && !getters.faqDetails)
    ) {
      PageTitle.constructTitle([getters.defaultPageTitle]);
    }

    if (typeof History !== 'undefined' && params !== null) {
      if (isTransitionFlag) {
        window.location = newFullUrl;
      } else {
        window.history.pushState(internalStateParams, null, newFullUrl);
      }
    }
  }
};

export const updatePageTitle = ({ getters, rootGetters }) => {
  if (!getters.urlParams.faq && !getters.urlParams.productID) {
    PageTitle.constructTitle([rootGetters.defaultPageTitle]);
  } else if (
    !getters.urlParams.faq
    && getters.urlParams.productID
    && rootGetters?.product?.displayName
  ) {
    PageTitle.constructTitle([rootGetters?.product?.displayName, rootGetters.defaultPageTitle]);
  }
};
